(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["build-your-bundle"] && !Shopify.designMode) return;
  try {
    (function () {
    var uid = 0;

    function init() {
      var modules = document.querySelectorAll('[data-byb]');
      modules.forEach(setupBundle);
      if (modules.length) setupJumpButton(modules[0]);
    }

    function setupJumpButton(module) {
      var jumpBtn = document.querySelector('[data-byb-jump]');
      if (!jumpBtn || jumpBtn.dataset.bybJumpInit) return;
      jumpBtn.dataset.bybJumpInit = '1';
      jumpBtn.removeAttribute('hidden');
      jumpBtn.addEventListener('click', function () {
        scrollToModule(module);
      });
    }

    function scrollToModule(module) {
      // On desktop the right info column is sticky over a taller left media
      // column, so the module stays pinned in the viewport until the column
      // releases near the bottom of the media column. scrollIntoView can't
      // reach it; compute the module's released position and scroll there.
      var sticky = module.closest('.product-info-col--sticky');
      var cell = module.closest('.product-info');
      if (sticky && cell && window.matchMedia('(min-width: 992px)').matches) {
        var HEADER_OFFSET = 150;
        var offsetWithinCol = module.getBoundingClientRect().top - sticky.getBoundingClientRect().top;
        var releasedColTop = (window.scrollY + cell.getBoundingClientRect().bottom) - sticky.offsetHeight;
        var target = releasedColTop + offsetWithinCol - HEADER_OFFSET;
        window.scrollTo({ top: Math.max(0, target), behavior: 'smooth' });
        return;
      }
      module.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function setupBundle(root) {
      if (root.dataset.bybInit) return;
      root.dataset.bybInit = '1';

      var format = root.getAttribute('data-money-format') || ('$' + '{' + '{amount}' + '}');

      Array.prototype.forEach.call(
        root.querySelectorAll('[data-byb-item]'),
        function (el) { new BybItem(el, format); }
      );
    }

    function BybItem(el, format) {
      this.el = el;
      this.format = format;
      this.uid = ++uid;
      this.cache = {};

      this.priceEl = el.querySelector('[data-byb-price]');
      this.imageLinkEl = el.querySelector('[data-byb-image-link]');
      this.imageEl = this.imageLinkEl ? this.imageLinkEl.querySelector('img') : null;
      this.titleEl = el.querySelector('[data-byb-title]');
      this.titleLinkEl = el.querySelector('[data-byb-title-link]');
      this.colorNameEl = el.querySelector('[data-byb-color-name]');
      this.sizesEl = el.querySelector('[data-byb-sizes]');
      this.includeBtn = el.querySelector('[data-byb-include]');
      this.errorEl = el.querySelector('[data-byb-error]');

      var data = JSON.parse(el.querySelector('[data-byb-data]').textContent);
      this.active = data;
      this.cache[data.url] = data;
      this.variant = pickDefaultVariant(el, data.variants);
      this.activeColorName = this.colorNameEl ? this.colorNameEl.textContent.trim() : '';

      var self = this;

      Array.prototype.forEach.call(el.querySelectorAll('[data-byb-color]'), function (link) {
        link.addEventListener('click', function (e) {
          e.preventDefault();
          self.selectColor(link);
        });
        link.addEventListener('mouseenter', function () {
          if (self.colorNameEl) self.colorNameEl.textContent = link.getAttribute('data-val');
        });
        link.addEventListener('mouseleave', function () {
          if (self.colorNameEl) self.colorNameEl.textContent = self.activeColorName;
        });
      });

      setupShowMoreColors(el.querySelector('[data-byb-colors]'));

      this.bindSizeInputs();

      if (this.includeBtn) {
        this.includeBtn.addEventListener('click', function () {
          // No size chosen yet on a multi-size product — prompt instead of adding.
          if (!self.variant) {
            self.showSizeError(true);
            return;
          }
          self.showSizeError(false);
          self.addToCart();
        });
      }

      this.renderPrice();
    }

    BybItem.prototype.addToCart = function () {
      var btn = this.includeBtn;
      if (!this.variant || (btn && btn.disabled)) return;

      if (btn) btn.disabled = true;
      document.body.classList.add('active-loader');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: this.variant.id, quantity: 1 }),
        cache: 'no-cache'
      })
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP error! Status: ' + r.status);
          return r.json();
        })
        .then(function () {
          // Same behaviour as the complete-the-look add-to-cart: refresh the
          // cart and open the drawer.
          if (typeof updateCartDrawer === 'function') {
            updateCartDrawer();
          } else {
            document.body.classList.add('cart-drawer-is-open');
          }
        })
        .catch(function (e) { console.error('Error adding bundle item to cart:', e); })
        .finally(function () {
          if (btn) btn.disabled = false;
          setTimeout(function () { document.body.classList.remove('active-loader'); }, 800);
        });
    };

    BybItem.prototype.bindSizeInputs = function () {
      var self = this;
      Array.prototype.forEach.call(this.sizesEl.querySelectorAll('[data-byb-size-input]'), function (input) {
        input.addEventListener('change', function () {
          self.variant = findVariant(self.active.variants, input.getAttribute('data-variant-id'));
          self.showSizeError(false);
          self.renderPrice();
        });
      });
    };

    BybItem.prototype.selectColor = function (link) {
      var self = this;
      var url = link.getAttribute('href');
      var colorName = link.getAttribute('data-val');
      if (this.active.url === url) return;

      this.activeColorName = colorName;
      if (this.colorNameEl) this.colorNameEl.textContent = colorName;

      // Swap to the selected swatch's image immediately — it's known at render
      // time, so there's no need to wait for the .js fetch (which only refreshes
      // the variants / price / title). image_tag emits a srcset, which the
      // browser prefers over src, so clear it for the new src to take effect.
      var swatchImage = link.getAttribute('data-byb-swatch-image');
      if (swatchImage && this.imageEl) {
        this.imageEl.removeAttribute('srcset');
        this.imageEl.removeAttribute('sizes');
        this.imageEl.src = swatchImage;
      }

      var cached = this.cache[url];
      if (cached) {
        this.applyColor(url, cached);
        return;
      }

      fetch(link.getAttribute('data-fetch-url'), { cache: 'force-cache' })
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP error! Status: ' + r.status);
          return r.json();
        })
        .then(function (product) {
          var mapped = mapProduct(product, url);
          self.cache[url] = mapped;
          self.applyColor(url, mapped);
        })
        .catch(function (e) { console.error('Error loading bundle color:', e); });
    };

    BybItem.prototype.applyColor = function (url, data) {
      this.active = data;

      if (this.imageLinkEl) this.imageLinkEl.href = url;
      if (this.titleLinkEl) this.titleLinkEl.href = url;
      if (this.titleEl) this.titleEl.textContent = data.title;

      Array.prototype.forEach.call(this.el.querySelectorAll('[data-byb-color]'), function (link) {
        var span = link.querySelector('span');
        if (span) span.classList.toggle('active', link.getAttribute('href') === url);
      });

      this.renderSizes(data.variants);
      this.variant = pickDefaultVariant(this.el, data.variants);
      this.showSizeError(false);
      this.renderPrice();
    };

    BybItem.prototype.renderSizes = function (variants) {
      var self = this;
      var showSizes = variants.length > 1;
      this.sizesEl.classList.toggle('hidden', !showSizes);
      this.sizesEl.innerHTML = '';
      if (!showSizes) return;

      variants.forEach(function (v, i) {
        var id = 'byb-size-' + self.uid + '-' + i;
        var option = document.createElement('div');
        option.className = 'option' + (v.available ? '' : ' option--unavailable');

        var input = document.createElement('input');
        input.type = 'radio';
        input.className = 'option__input sr-only';
        input.name = 'byb-size-' + self.uid;
        input.id = id;
        input.value = v.id;
        input.checked = self.variant ? v.id === self.variant.id : false;
        input.setAttribute('data-byb-size-input', '');
        input.setAttribute('data-variant-id', v.id);

        var label = document.createElement('label');
        label.className = 'option__label';
        label.setAttribute('for', id);
        label.textContent = v.size;

        option.appendChild(input);
        option.appendChild(label);
        self.sizesEl.appendChild(option);
      });

      this.bindSizeInputs();
    };

    BybItem.prototype.showSizeError = function (show) {
      if (!this.errorEl) return;
      this.errorEl.textContent = show ? 'Please choose your size' : '';
    };

    BybItem.prototype.renderPrice = function () {
      if (this.priceEl && this.variant) {
        this.priceEl.textContent = money(this.variant.price, this.format);
      }
    };

    function pickDefaultVariant(el, variants) {
      var checked = el.querySelector('[data-byb-size-input]:checked');
      if (checked) {
        var match = findVariant(variants, checked.getAttribute('data-variant-id'));
        if (match) return match;
      }
      // Single-variant products auto-resolve; multi-size products require an
      // explicit size choice (no pre-selection).
      if (variants.length === 1) return variants[0];
      return null;
    }

    function findVariant(variants, id) {
      for (var i = 0; i < variants.length; i++) {
        if (id == null ? variants[i].available : String(variants[i].id) === String(id)) {
          return variants[i];
        }
      }
      return null;
    }

    function setupShowMoreColors(list) {
      if (!list || list.dataset.bybShowMoreInit) return;
      list.dataset.bybShowMoreInit = '1';

      var liItems = Array.prototype.slice.call(list.querySelectorAll('li'));
      var total = liItems.length;
      if (total <= 10) return;

      liItems.forEach(function (li, index) {
        if (index >= 10) li.style.display = 'none';
      });

      var showMoreLi = document.createElement('li');
      showMoreLi.className = 'show-more-colors';
      showMoreLi.textContent = '+' + (total - 10);
      showMoreLi.style.cursor = 'pointer';
      list.appendChild(showMoreLi);

      showMoreLi.addEventListener('click', function () {
        liItems.forEach(function (li, index) {
          if (index >= 10) li.style.display = 'inline-block';
        });
        showMoreLi.style.display = 'none';
      });
    }

    function mapProduct(product, url) {
      return {
        url: url,
        title: (product.title || '').split('|')[0].trim(),
        variants: (product.variants || []).map(function (v) {
          return {
            id: v.id,
            available: !!v.available,
            price: v.price,
            size: (v.title || '').split('/').pop().trim()
          };
        })
      };
    }

    function money(cents, format) {
      var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
      var placeholder = match ? match[1] : 'amount';
      // Whole amounts show with no decimals; anything with cents shows the
      // exact value at 2 decimals. We intentionally ignore the store's
      // "no decimals" money format here so a non-round total (e.g. after a
      // % discount) still shows its cents rather than being truncated.
      var precision = (cents % 100 === 0) ? 0 : 2;
      return formatMoney(cents, format, placeholder, precision);
    }

    function formatMoney(cents, format, placeholder, precision) {
      function fmt(number, thousands, decimal) {
        if (isNaN(number) || number == null) return '0';
        number = (number / 100).toFixed(precision);
        var parts = number.split('.');
        var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        var rest = parts[1] ? decimal + parts[1] : '';
        return dollars + rest;
      }
      var value;
      switch (placeholder) {
        case 'amount_with_comma_separator':
        case 'amount_no_decimals_with_comma_separator':
          value = fmt(cents, '.', ','); break;
        case 'amount_with_apostrophe_separator':
          value = fmt(cents, "'", '.'); break;
        case 'amount_with_space_separator':
        case 'amount_no_decimals_with_space_separator':
          value = fmt(cents, ' ', ','); break;
        default:
          value = fmt(cents, ',', '.');
      }
      return format.replace(/\{\{\s*\w+\s*\}\}/, value);
    }

    if (document.readyState !== 'loading') {
      init();
    } else {
      document.addEventListener('DOMContentLoaded', init);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-messages"] && !Shopify.designMode) return;
  try {
    const productMessageTimers = new WeakMap();

  function stopProductMessages(root) {
    const timer = productMessageTimers.get(root);
    if (timer) clearInterval(timer);
    productMessageTimers.delete(root);
  }

  function startProductMessages(root, showNext) {
    stopProductMessages(root);
    const interval = Number(root.dataset.interval) || 4000;
    productMessageTimers.set(root, setInterval(showNext, interval));
  }

  function initProductMessages(root) {
    if (root.dataset.ready === 'true') return;

    const lines = Array.from(root.querySelectorAll(':scope > .product-messages__line'));
    if (lines.length < 2) return;

    root.dataset.ready = 'true';
    root.classList.add('is-rotating');

    let index = 0;
    lines.forEach(function (line, lineIndex) {
      if (lineIndex === 0) {
        line.classList.add('is-active');
        line.removeAttribute('aria-hidden');
      } else {
        line.setAttribute('aria-hidden', 'true');
      }
    });

    function showNext() {
      lines[index].classList.remove('is-active');
      lines[index].setAttribute('aria-hidden', 'true');
      index = (index + 1) % lines.length;
      lines[index].classList.add('is-active');
      lines[index].removeAttribute('aria-hidden');
    }

    root.addEventListener('mouseenter', function () {
      stopProductMessages(root);
    });
    root.addEventListener('mouseleave', function () {
      startProductMessages(root, showNext);
    });

    startProductMessages(root, showNext);
  }

  function initProductMessagesIn(scope) {
    const rootNode = scope && scope.querySelectorAll ? scope : document;
    rootNode.querySelectorAll('[data-product-messages]').forEach(initProductMessages);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initProductMessagesIn(document);
    });
  } else {
    initProductMessagesIn(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initProductMessagesIn(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('[data-product-messages]').forEach(stopProductMessages);
  });
  } catch(e) { console.error(e); }
})();

})();
